<a routerLink="/home" class="logo-container" aria-label="Go to home">
  <img src="/assets/zpax-mini-logo.png" alt="Z.PAX" class="zpax-logo">
  <span aria-hidden="true" class="logo-divider"></span>
  <img src="/assets/rc-logo.png" alt="Rehab Connect" class="rc-logo">
</a>
